import { ArrowLeft01Icon, ArrowRight01Icon } from '@hugeicons-pro/core-stroke-rounded';
import type { BlurViewProps } from 'expo-blur';
import React from 'react';
import { View } from 'react-native';

import { ButtonWrapper } from '@/components/ui/ButtonWrapper';
import { SafeBlurView } from '@/components/ui/SafeBlurView';

const SIDE_ZONE_WIDTH = 64;
const ARROW_HIT_SLOP = { top: 16, bottom: 16, left: 16, right: 16 };

type CarouselSide = 'left' | 'right';

interface ICarouselArrowButtonProps {
  side: CarouselSide;
  icon: any;
  onPress: () => void;
  disabled?: boolean;
  blurTarget?: BlurViewProps['blurTarget'];
}

const CarouselArrowButton: React.FC<ICarouselArrowButtonProps> = ({
  side,
  icon,
  onPress,
  disabled,
  blurTarget,
}) => {
  const positionClass =
    side === 'left'
      ? 'absolute bottom-0 left-0 top-0 z-30 h-full items-center justify-center'
      : 'absolute bottom-0 right-0 top-0 z-30 h-full items-center justify-center';

  return (
    <View className={positionClass} style={{ width: SIDE_ZONE_WIDTH }} pointerEvents="box-none">
      <SafeBlurView
        blurTarget={blurTarget}
        intensity={80}
        tint="dark"
        className="overflow-hidden rounded-full">
        <ButtonWrapper
          icon={icon}
          iconSize={28}
          iconClassName="color-white"
          size="md"
          className="bg-transparent"
          onPress={onPress}
          isDisabled={disabled}
          hitSlop={ARROW_HIT_SLOP}
        />
      </SafeBlurView>
    </View>
  );
};

interface ICarouselSideArrowsProps {
  onPrev: () => void;
  onNext: () => void;
  canPrev: boolean;
  canNext: boolean;
  blurTarget?: BlurViewProps['blurTarget'];
}

export const CarouselSideArrows: React.FC<ICarouselSideArrowsProps> = ({
  onPrev,
  onNext,
  canPrev,
  canNext,
  blurTarget,
}) => {
  return (
    <>
      <CarouselArrowButton
        side="left"
        icon={ArrowLeft01Icon}
        onPress={onPrev}
        disabled={!canPrev}
        blurTarget={blurTarget}
      />
      <CarouselArrowButton
        side="right"
        icon={ArrowRight01Icon}
        onPress={onNext}
        disabled={!canNext}
        blurTarget={blurTarget}
      />
    </>
  );
};
